import { Box, Heading, Link, Text, VStack } from '@chakra-ui/react'
import React from 'react'

export const PrivacyPolicy = () => {
  return (
    <Box px={8} py={6}>
      <VStack spacing={4} align='start'>
        <Text fontSize='lg' fontWeight='bold'>
          Voimassa 01.03.2022 alkaen
        </Text>
        <Heading as='h2' color='teal.500' id='verkkokauppa'>
          Verkkokauppa
        </Heading>
        <Text fontSize='md'>
          Myfetch.fi on ENEXUS Oy:n (y-tunnus&nbsp;2686543-2) / Fetch:n markkinapaikka.
          Verkkokaupassa myydään tuotteita ja palveluita yksityishenkilöille ja yrityksille Suomeen
          ja EU-alueelle. Tuotteiden hinnat sisältävät arvonlisäveron. Pidätämme oikeuden hintojen
          ja toimituskulujen muutoksiin.
        </Text>

        <Heading as='h2' color='teal.500' id='tilaaminen'>
          Tilaaminen
        </Heading>
        <Text fontSize='md'>
          Tuotteet tilataan verkkokaupassa siirtämällä ne ostoskoriin ja maksamalla ostoskorin
          sisältö verkkokaupan kassalla. Kaikki asiakastiedot käsitellään luottamuksellisesti.
          Tilauksen yhteydessä kysyttyjä yhteystietoja ei käytetä muuhun kuin tilauksen toimitukseen
          tai siinä ilmenevien epäselvyyksien selvittämiseen. Tilatessasi verkkokaupasta sinun
          edellytetään tutustuneen ja sitoutuneen kulloinkin voimassa oleviin toimitusehtoihin.
        </Text>

        <Heading as='h2' color='teal.500' id='maksutavat'>
          Maksutavat
        </Heading>
        <Text fontSize='md'>
          <strong>Verkkopankkien verkkomaksupainikkeet</strong>
        </Text>
        <Text fontSize='md'>
          <strong>Korttimaksut (Visa, Visa Electron, Mastercard ja Business Eurocard)</strong>
          Maksukortilla maksaminen verkkokaupassamme on vaivatonta ja turvallista.
          Korttimaksamisesta verkkokaupassamme huolehtii&nbsp;Klarna
          AB&nbsp;yhteistyössä&nbsp;Digital River&nbsp;:n ja&nbsp;Enexus Oy:n kanssa.
          Maksutapahtuman aikana luottokorttitietoja käsitellään aina suojatussa verkkoyhteydessä.
          Korttinumeroita ei tallenneta verkkokaupan tai&nbsp;Enexus OY:n tietojärjestelmiin vaan ne
          käsitellään teknisen palveluntuottajan&nbsp;Klarna AB:n toimesta.
        </Text>
        <Text fontSize='md'>
          <strong>Maksujenvälittäjän yhteystiedot:</strong>{' '}
          <Link href='https://www.klarna.com/fi/tietoja-meista/yhteystiedot/'>
            klarna.com/fi/tietoja-meista/yhteystiedot/
          </Link>
        </Text>

        <Heading as='h2' color='teal.500' id='tilaus-ja-maksuvahvistus'>
          Tilaus- ja maksuvahvistus
        </Heading>
        <Text fontSize='md'>
          Onnistuneen tilauksen jälkeen sähköpostiisi lähetetään tilausvahvistus.&nbsp;Lisäksi saat
          reittisuunnittelun jälkeen Fetch:ltä tekstiviestin, jonka kautta pääset seuraamaan
          toimituksen etenemistä ja hallinnoimaan tilaustasi.&nbsp;Vahvistusviestien lähettäminen
          edellyttää matkapuhelinnumeron ja sähköpostiosoitteen antamista tilauksen yhteydessä.
        </Text>

        <Heading as='h2' color='teal.500' id='vaihto-ja-palautusehdot-seka-ongelmatilanteet'>
          Vaihto- ja palautusehdot sekä ongelmatilanteet
        </Heading>
        <Text fontSize='md'>
          Vaihto- ja palautusasioissa ole yhteydessä palveluntarjoajaan. Enexus Oy vastaa vain itse
          myymistään tuotteista. Vaihto- ja palautusehdot tuotteille löydät kunkin palveluntarjoajan
          omilta sivuilta.
        </Text>
      </VStack>
    </Box>
  )
}

export default PrivacyPolicy
